package com.wintermar.inspection.core.ui.theme.color.palette.accent

import androidx.compose.ui.graphics.Color
import com.wintermar.inspection.core.ui.theme.color.model.ColorVariant

val GreenColorVariant = ColorVariant(
    n100 = Color(0xFFF0FDF4),
    n200 = Color(0xFFDCFCE7),
    n300 = Color(0xFFBBF7D0),
    n400 = Color(0xFF86EFAC),
    n500 = Color(0xFF4ADE80),
    n600 = Color(0xFF22C55E),
    n700 = Color(0xFF16A34A),
    n800 = Color(0xFF15803D),
    n900 = Color(0xFF166534),
    n1000 = Color(0xFF104726)
)
